import sa from 'sa-sdk-javascript';
import isEmpty from 'lodash/isEmpty';
import isBoolean from 'lodash/isBoolean';

import pConfig from 'pConfig';
import { store } from 'src/redux/store';
import Api from 'api';

sa.init({
  debug_mode: false,
  show_log: false,
  server_url: pConfig.SA_SERVER_URL,
  is_track_single_page: false,
  heatmap_url: 'https://static.sensorsdata.cn/sdk/1.13.4/heatmap.min.js',
  heatmap: {
    clickmap: 'default',
    scroll_notice_map: 'not_collect'
  }
});
sa.registerPage({ project: 'truck' });
sa.identify();
if (signedInBoohee()) {
  Api.getSaIdentity().then(res => {
    if (res.data) {
      const { distinct_id } = res.data;
      sa.login(distinct_id);
    }
  });
}

function signedInBoohee() {
  const { token } = store.getState();
  return !isEmpty(token) && !isBoolean(token);
}

export default sa;
